import React, {useEffect, useState} from "react"
import {Col, Row} from "react-bootstrap"
import {Link} from "react-router-dom";
import logoFooter3 from "Assets/images/footer-img-3.png";
import logoSanseWhite from "Assets/images/logo-sanse-white.png";
import lema from "Assets/images/Lema_RRSS_blanco-300x130.png";
import comMadrid from "Assets/images/com_madrid.png";
import comMadridUni from "Assets/images/com_madrid_uni.png";

import gob600 from "Assets/images/corresponsables2026.png";
import {PrivacyPolicyLink} from "Components/Link/PrivacyPolicyLink";
import {LegalWarningLink} from "Components/Link/LegalWarningLink";
import {DataProtectionLink} from "../../Components/Link/DataProtectionLink";
import {
    LEGAL_WARNING_SUMMER_SANSE_DOC_URL,
    PRIVACY_POLICY_DOC_URL,
} from "../../Config/Router/Routes";
import {useQuery} from "react-query";
import {getConfig} from "../../Api/Query/ConfigQuery";

export const Footer: React.FC = () => {

    const [termsAndConditionsDocUrl, setTermsAndConditionsDocUrl] = useState('#');

    const getTermsAndConditionsDocUrl = useQuery({
        enabled: false,
        queryKey: ['termsAndConditionsDocUrl'],
        queryFn: () => getConfig('pdf_terminos_normas_y_condiciones_de_inscripcion'),
        onSuccess: (response: any) => {
            const item = response.data?._result;

            if (item?.value) {
                setTermsAndConditionsDocUrl(item.value)
            }
        }
    })

    useEffect(() => {
        getTermsAndConditionsDocUrl.refetch()
    }, []);

    return (
        <Row id={"footer"}>
            <Col className={"col-12 col-md-10 mx-auto"}>
                <Row>
                    <Col className={"col-12 col-sm-6 col-lg-6 mx-auto"}>
                        <span className={"heading"}>Sanse Concilia</span>
                        <span>Concejalía de Educación del Ayuntamiento de San Sebastián de los Reyes</span>
                        <br/>
                        <LegalWarningLink/>&nbsp;·&nbsp;<PrivacyPolicyLink/>&nbsp;·&nbsp;<DataProtectionLink/>
                        &nbsp;·&nbsp;
                        <a href={termsAndConditionsDocUrl} target={"_blank"}>Términos y condiciones</a>
                        <br/>
                        <br/>

                        <span className={"heading"}>Summer Sanse</span>
                        <span>Concejalía de Educación del Ayuntamiento de San Sebastián de los Reyes</span>
                        <br/>
                        <a
                            href={LEGAL_WARNING_SUMMER_SANSE_DOC_URL}
                            target={"_blank"}
                        >Aviso Legal</a>
                        &nbsp;·&nbsp;
                        <a href={PRIVACY_POLICY_DOC_URL} target={"_blank"}>Política de Privacidad</a>
                        &nbsp;·&nbsp;<DataProtectionLink/>
                        &nbsp;·&nbsp;
                        <a href={termsAndConditionsDocUrl} target={"_blank"}>Términos y condiciones</a>
                    </Col>
                    <Col className={"col-12 col-sm-6 col-lg-6 mx-auto"}>
                        <span className={"heading"}>Contacto</span>
                        <span>Si necesitan ponerse en contacto con nosotros para cualquier aclaración o duda se pueden dirigir a nosotros en:</span>
                        <span className={"font-weight-bold"}>Centro Municipal “Lopillo”, Planta baja, Derecha.</span>
                        <span>Avenida Ramón y Cajal, 9, 28703, San Sebastián de los Reyes, Madrid</span>
                        <span>Teléfono:&nbsp;&nbsp;
                            <Link
                            to={"tel:916588999"}>91 658 89 99</Link> - <Link
                            to={"916588993"}>91 658 89 93</Link></span>
                        <span>Email: <a href="mailto:sanseconcilia@ssreyes.org">sanseconcilia@ssreyes.org</a></span>
                    </Col>
                </Row>

                <Row style={{marginTop: '60px'}}>
                    <Col className="col-12">
                        <Row>
                            <Col
                                className="col-12 col-sm-6 col-lg-6 col-xl-6 col-xxl-6">
                                <div style={{marginBottom:'20px'}}>
                                    <small>Programas y actividades financiados con cargo a los fondos recibidos por la Comunidad de Madrid del Ministerio de Igualdad, de la Secretaría de Estado de Igualdad y para la Erradicación de la Violencia contra las Mujeres, en el marco del Plan Corresponsables y de la subvención para actividades extraescolares de la Consejería de Educación de la Comunidad de Madrid.</small>
                                </div>
                                <p className="text-center">
                                    <img src={gob600} alt="Logo" style={{maxWidth: "80%", display:"block",margin:'0 auto 20px auto'}}/>
                                </p>
                            </Col>
                            <Col
                                className="col-12 col-sm-6 col-lg-6 col-xl-4 col-xxl-3 d-flex align-items-center justify-content-center justify-content-lg-start pb-4">
                                <img src={comMadrid} alt="Comunidad de Madrid" style={{maxWidth: "300px"}}/>
                            </Col>
                            <Col
                                className="col-12 col-sm-6 col-lg-6 col-xl-4 col-xxl-3 d-flex align-items-center justify-content-center justify-content-lg-start pb-4">
                                <img src={comMadridUni} alt="Comunidad de Madrid" style={{maxWidth: "300px"}}/>
                            </Col>
                            <Col
                                className="col-12 col-sm-6 col-lg-6 col-xl-4 col-xxl-3 d-flex align-items-center justify-content-center justify-content-lg-start pb-4">
                                <img src={logoSanseWhite} alt="Logo" style={{minWidth: "225px", maxWidth: '100%'}}/>
                            </Col>
                            <Col
                                className="col-12 col-sm-6 col-lg-6 col-xl-4 col-xxl-3 d-flex align-items-center justify-content-center justify-content-lg-start pb-4">
                                <img src={logoFooter3} alt="Logo"/>
                            </Col>
                            <Col
                                className="col-12 col-sm-6 col-lg-3 col-xl-4 col-xxl-3 d-flex align-items-center justify-content-center justify-content-lg-start pb-4">
                                <img src={lema} alt="Logo" style={{maxWidth: "150px"}}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>


            </Col>
        </Row>
    )
}
